import type { FC, ReactNode } from 'react'

import { siteConfig } from '@/constants/site'

type LogoProps = {
    className?: string
}

/**
 * The business's own wordmark. The image is sized by height in
 * `kitchen.css` (`.site-logo-image`), so it always fits the bar it sits
 * in and keeps its proportions.
 */
export const Logo: FC<LogoProps> = ({ className }): ReactNode => {
    return (
        <span className={className ? `site-logo ${className}` : 'site-logo'}>
            <img
                src='/images/ng/logo-wordmark.png'
                width={476}
                height={106}
                alt={`${siteConfig.name} logo`}
                className='site-logo-image'
            />
        </span>
    )
}
